import { EQUIPMENT_FIELDS_ID } from '../../_constants/common';
import {
  SAVED_LIST_COLUMN,
  SORT_DIRECTIONS,
  SORT_TYPE,
  SavedListColumnConfig,
  SavedListTableSchema
} from './types';

const equipmentkey = (data) => {
  for (const key of Object.values(EQUIPMENT_FIELDS_ID)) {
    if (data.equipment[key]) {
      return key;
    }
  }
  return '';
};
export const sortByEquipment = (a, b, _columnId) => {
  const keyA = equipmentkey(a);
  const keyB = equipmentkey(b);
  const valueA = a.equipment[keyA];
  const valueB = b.equipment[keyB];

  const equipmentFieldsID = Object.values(EQUIPMENT_FIELDS_ID);
  if (!valueA && !valueB) {
    return 0;
  }

  if (!valueA) {
    return 1;
  }

  if (!valueB) {
    return -1;
  }

  if (keyA === keyB) {
    return valueA.toLowerCase().localeCompare(valueB.toLowerCase());
  } else {
    return equipmentFieldsID.indexOf(keyA) - equipmentFieldsID.indexOf(keyB);
  }
};

export const getSavedListTableSchema = (
  isInstantAccessUser = false,
  isCspUser = false,
  isAssociateEquipmentToSavedList = false
): SavedListTableSchema => {
  return [
    {
      id: SAVED_LIST_COLUMN.NAME,
      label: 'MA_NAME',
      behavior: 'sortable',
      sortType: SORT_TYPE.ALPHANUMERIC,
      width: '246px'
    },
    {
      id: SAVED_LIST_COLUMN.ACTIONS,
      width: '50px'
    },
    {
      id: SAVED_LIST_COLUMN.QUANTITY,
      label: 'MO_ITEMS',
      width: '120px',
      behavior: 'sortable',
      sortType: SORT_TYPE.NUMERIC
    },
    ...(isAssociateEquipmentToSavedList
      ? [
          {
            id: SAVED_LIST_COLUMN.EQUIPMENT,
            label: 'CAT_EQUIPMENT',
            width: '210px',
            behavior: 'sortable',
            sortType: SORT_TYPE.EQUIPMENT
          } as SavedListColumnConfig
        ]
      : []),
    {
      id: SAVED_LIST_COLUMN.CREATED_BY,
      label: 'CREATED_BY',
      behavior: 'sortable',
      sortType: SORT_TYPE.ALPHANUMERIC,
      width: isInstantAccessUser && !isCspUser ? '308px' : '238px'
    },
    {
      id: SAVED_LIST_COLUMN.UPDATED_DATE,
      label: 'REQUISITIONLIST_UPDATED',
      width: isInstantAccessUser && !isCspUser ? '210px' : '140px',
      behavior: 'sortable',
      sortType: SORT_TYPE.DATE,
      sortDirection: SORT_DIRECTIONS.DESC
    },
    {
      id: SAVED_LIST_COLUMN.LIST_TYPE,
      label: 'REQUISITIONLIST_TYPE',
      width: '140px',
      align: 'center'
    }
  ];
};

export const getItemToString = (item) => {
  if (!item) {
    return '';
  }
  if (typeof item === 'string') {
    return item;
  }
  const {
    assetId = '',
    assetName = '',
    model = '',
    serialNumber = ''
  } = item || {};
  const equipmentAssetId = assetId ? `${assetId} ` : '';
  const equipmentAssetName = assetName ? `${assetName} ` : '';
  const equipmentModel = model ?? '';
  const equipmentSerialNumber = serialNumber ?? '';
  const hyphenSeparator = model && serialNumber ? ' - ' : '';
  const startWithBracket =
    model || (serialNumber && !serialNumber.startsWith('(')) ? '(' : '';
  const endWithBracket =
    model || (serialNumber && !serialNumber.endsWith(')')) ? ')' : '';

  return `${equipmentAssetId}${equipmentAssetName}${startWithBracket}${equipmentModel}${hyphenSeparator}${equipmentSerialNumber}${endWithBracket}`;
};
